/**
 * Copyright 2023 Design Barn Inc.
 */

'use client';

import React, { useEffect } from 'react';

import { useIframeMessaging } from '../../contexts/iframe-messaging-context';
import { deimosGetSession } from '../../utils/api-requests';

/* this page is displayed in a hidden iframe so no UI is necessary */
export default function Page(): React.ReactElement {
  const { sessionCheckResult } = useIframeMessaging();

  useEffect(() => {
    const fetchSession = async (): Promise<void> => {
      const session = await deimosGetSession();

      sessionCheckResult(session);
    };

    fetchSession();
  }, [sessionCheckResult]);

  return <div />;
}
